import axios from 'axios';
import store from '../store';
import router from '../router';
import { Toast, Dialog } from 'vant';
// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // api的base_url
  timeout: 60000 * 2, // 请求超时时间
  // withCredentials: true,
  headers: { 'AJAX-PF-CODE': 'saas' }, // 表明该请求来自于哪一个系统
});
// request拦截器
service.interceptors.request.use(
  config => {
    if (config.isZaiartUrl) {
      let baseUrl =
        process.env.VUE_APP_FLAG === 'prod'
          ? 'https://b.zai-art.com'
          : 'https://t1gateway.zai-art.com';
      config.baseURL = baseUrl;
    }
    // 随机数
    config.headers['ZY_TRANSID'] = Math.random()
      .toString(36)
      .substr(2);

    // token
    if (store.state.app.token) {
      config.headers['USER_TOKEN_HEAD'] = store.state.app.token;
      config.headers['X_AUTH_MANAGER_ID'] = store.state.app.userId;
    }

    // shopId
    if (store.state.app.shopId) {
      config.headers['ZY_SHOP_ID'] = store.state.app.shopId;
    }
    // if (store.state.app.userId) {
    //   config.headers['X_AUTH_MANAGER_ID'] = store.state.app.userId;
    // }
    // contentType
    if (config.method === 'post') {
      config.headers['Content-Type'] = 'application/json';
      if (config.headertype) {
        config.headers['Content-Type'] = config.headertype;
      }
      if (config.data) {
        config.data = JSON.stringify(config.data);
      }
    }

    return config;
  },
  error => {
    // Do something with request error
    return Promise.reject(error);
  },
);

// respone拦截器
service.interceptors.response.use(
  response => {
    if (response.data.code === 1) {
      return response.data;
    }

    // 未登录
    if (response.data.code === 9201001) {
      Toast(response.data.message);
      /* 登录超时 暂未处理*/
      // store.dispatch('loginExpired');
      // router.push({ path: '/login' });
      wx.miniProgram.redirectTo({
        url: `/pages/login/login?clear=1`,
      });
      return Promise.reject(response.data);
    }

    // 没有操作权限
    if (response.data.code == 9201002) {
      Dialog.alert({
        message: '用户无此操作权限',
      }).then(() => {
        router.go(-1);
      });
      return Promise.reject(response.data);
    }

    // 没有shopId
    if (response.data.code === 9201005) {
      router.replace({ path: '/shop/list' });
      return Promise.reject(response.data);
    }

    Toast(response.data.message);
    return Promise.reject(response.data);
  },
  error => {
    Toast('网络请求失败, 请检查网络连接后重试');
    return Promise.reject(error);
  },
);

export default service;
